import { useSupportChatStore } from './useSupportChatStore'

/**
 * Счётчик непрочитанных ответов поддержки для шапки приложения.
 *
 * Подключает сокет и подтягивает обращения СРАЗУ после входа, а не при открытии
 * чата: иначе гость узнаёт об ответе только из пуша, а на открытой вкладке
 * (или при выключенных пушах) не узнаёт вовсе.
 *
 * Идемпотентно: и стор, и сокет — синглтоны, повторный вызов из другого места
 * ничего не ломает.
 */
export function useSupportUnreadBadge(isLoggedIn: Ref<boolean> | ComputedRef<boolean>) {
  const store = useSupportChatStore()

  const unreadCount = computed(() => store.unreadTotal)
  const hasUnread = computed(() => unreadCount.value > 0)
  const unreadDisplay = computed(() => (unreadCount.value > 99 ? '99+' : String(unreadCount.value)))

  watch(
    isLoggedIn,
    (loggedIn) => {
      if (!import.meta.client) return
      if (loggedIn) {
        store.startRealtime()
        void store.fetchTickets()
      } else {
        store.reset()
      }
    },
    { immediate: true },
  )

  return { unreadCount, hasUnread, unreadDisplay }
}
